<template>
  <v-progress-linear
    :active="loading"
    class="global-progress-bar"
    height="4"
    :indeterminate="true"
  />
</template>

<script>
/**
 * Display a global progress bar just below the toolbar.
 * This component can check if any of the given list of flags (as the `flags` prop) is active.
 * The flags must be booleans, and if any of them is true tis component will be shown.
 */
export default {
  props: {
    /* The namespace of the store where to look the values to activate the progress bar */
    namespace: {
      type: String
    },
    /* An array with the names of the properties of the store to look for */
    flags: {
      type: Array,
      validator: val => val.every(item => typeof item === "string")
    }
  },
  computed: {
    loading() {
      const state = this.namespace
        ? this.$store.state[this.namespace]
        : this.$store.state;
      return this.flags.some(value => state[value]);
    }
  }
};
</script>

<style scoped>
.global-progress-bar {
  position: fixed;
  top: -14px;
  z-index: 3;
}
</style>